function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(-0.828 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "sync"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M5.072,25.056A14.08,14.08,0,0,1,.055,17.741a1.428,1.428,0,0,1,.366-1.4,1.489,1.489,0,0,1,1.418-.389A1.461,1.461,0,0,1,2.89,16.963a11.172,11.172,0,0,0,3.982,5.8,11.412,11.412,0,0,0,13.731,0,11.194,11.194,0,0,0,1.961-1.91l1.16-.336.183,3.214a14.352,14.352,0,0,1-18.834,1.32Zm19.95,1.052-.387-6.854-6.558,1.9a1.476,1.476,0,0,1-1.821-.981,1.443,1.443,0,0,1,.99-1.794l8.339-2.409a1.492,1.492,0,0,1,1.264.205,1.442,1.442,0,0,1,.621,1.1l.49,8.676a1.456,1.456,0,0,1-1.388,1.524l-.083,0A1.461,1.461,0,0,1,25.023,26.108Zm.052-15.116a11.167,11.167,0,0,0-3.982-5.8,11.412,11.412,0,0,0-13.731,0A11.194,11.194,0,0,0,5.4,7.1l-1.16.336L4.059,4.221A14.374,14.374,0,0,1,22.892,2.9a14.082,14.082,0,0,1,5.017,7.316A1.443,1.443,0,0,1,26.888,12a1.5,1.5,0,0,1-.4.053A1.47,1.47,0,0,1,25.075,10.993Zm-23.961.793a1.438,1.438,0,0,1-.62-1.1L0,2.008a1.439,1.439,0,0,1,.66-1.3A1.494,1.494,0,0,1,2.14.626a1.443,1.443,0,0,1,.8,1.221L3.329,8.7l6.558-1.9a1.493,1.493,0,0,1,1.44.334,1.43,1.43,0,0,1,.417,1.394,1.456,1.456,0,0,1-1.026,1.047l-8.339,2.41a1.5,1.5,0,0,1-1.265-.206Z",
  transform: "translate(0.829)",
  fill: "#fff"
})));

function SvgDesktopI4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.965,
    height: 27.964,
    viewBox: "0 0 27.965 27.964",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopI4);
export default __webpack_public_path__ + "static/media/desktopI4.a0dad485.svg";
export { ForwardRef as ReactComponent };